import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PageResponse } from '@/core/api/sicom-api/sistema/usuario/usuario.model';
import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { PcmsoCreateRequest, PcmsoRequest, PcmsoUpdateRequest } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { postPcmso } from '@/core/api/sicom-api/registro/medico/pcmso/api/pcmso-api-post';
import { uploadPcmsoDocumento } from '@/core/api/sicom-api/registro/medico/pcmso/api/pcmso-api-upload-documento';
import { downloadPcmsoAnexo } from '@/core/api/sicom-api/registro/medico/pcmso/api/pcmso-api-download-anexo';
import { uploadPcmsoAnexo } from '@/core/api/sicom-api/registro/medico/pcmso/api/pcmso-api-upload-anexo';
import { PcmsoUploadResponse } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { putPcmso } from '@/core/api/sicom-api/registro/medico/pcmso/api/pcmso-api-put';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PcmsoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.pcmso.base;

    buscar(params: Pessoa & { page?: number; size?: number }, context?: HttpContext): Observable<PageResponse<PcmsoRequest>> {
        let httpParams = new HttpParams().set('id', params.id).set('uf', params.uf);
        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }
        if (params.size !== undefined) {
            httpParams = httpParams.set('size', params.size.toString());
        }
        return this.http.get<PageResponse<PcmsoRequest>>(`${this.PATH}/consulta`, { params: httpParams, context });
    }

    buscarInativo(params: Pessoa & { page?: number; size?: number }, context?: HttpContext): Observable<PageResponse<PcmsoRequest>> {
        let httpParams = new HttpParams().set('id', params.id).set('uf', params.uf);
        if (params.page !== undefined) {
            httpParams = httpParams.set('page', params.page.toString());
        }
        if (params.size !== undefined) {
            httpParams = httpParams.set('size', params.size.toString());
        }

        return this.http.get<PageResponse<PcmsoRequest>>(`${this.PATH}/inativo/consulta`, { params: httpParams, context });
    }

    criar(payload: PcmsoCreateRequest, context?: HttpContext): Observable<PcmsoRequest> {
        return postPcmso(this.http, this.rootUrl, payload, context).pipe(map((r) => (r as any).body as PcmsoRequest));
    }

    uploadDocumento(file: File, context?: HttpContext): Observable<number> {
        return uploadPcmsoDocumento(this.http, this.rootUrl, file, context).pipe(
            map((r) => (r as any).body as PcmsoUploadResponse),
            map((resp) => resp.idDocumento)
        );
    }

    downloadAnexo(params: { uf: string; idMedico: number; nuRegistro: number | string }, context?: HttpContext): Observable<Blob> {
        return downloadPcmsoAnexo(this.http, this.rootUrl, params, context).pipe(map((r) => (r as any).body as Blob));
    }

    uploadAnexoRegistro(params: { uf: string; idMedico: number; nuRegistro: number | string }, file: File, context?: HttpContext): Observable<void> {
        return uploadPcmsoAnexo(this.http, this.rootUrl, params, file, context).pipe(map(() => void 0));
    }

    editar(params: { uf: string; idMedico: number | string; nuRegistro: number | string }, payload: PcmsoUpdateRequest, context?: HttpContext): Observable<void> {
        return putPcmso(this.http, this.rootUrl, params, payload, context).pipe(map(() => void 0));
    }
}
